// 申请发票
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    out_trade_no: string;
    email: string;
    phone: string;
    title?: string;
}

export interface IOutput {
    status: number;
}

export const applyInvoice = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.APPLY_PAYMENT_INVOICE, data).then((res: IResponse<IOutput>) => res.data);
};
